import {IPaletteOptions} from "../interfaces/themes/ITheme";

export const LightPalette: IPaletteOptions = {
	primary: {
		main: '#FF4F4F',
		light: '#FF8080',
		dark: '#ab3131',
		contrastText: '#FFFFFF',
	},
	secondary: {
		main: '#FFFFFF',
		light: '#D800FF',
		dark: '#D800FF',
		contrastText: "#D800FF"
	},
	text: {
		primary: '#222222',
		secondary: '#FFFFFF',
		tertiary: '#444444',
		quaternary: '#444444',
		disabled: '#D800FF',
		hint: '#D800FF',
	},
	shadow: {
		main: '-4px 4px 0px #0000004f',
		hover: '-3px 3px 0px #0000004f',
		inset: 'inset -4px 4px 0px #0000004f, inset 2px -2px 2px #0000002f',
	}
};
